import {Logic} from './Type'

export class ModalState extends Logic.Type {
    Confirmation: boolean = false
    NoBalanceError: boolean = false
    BuyWhat: number
}


// WEBPACK FOOTER //
// ./src/Logic/Modal.ts